import { api } from '../config/api';

export const inventarioService = {
  // Obtener movimientos de inventario
  getMovimientos: async (params = {}) => {
    try {
      const data = await api.get('/api/movimientos-inventario/', params);
      return data;
    } catch (error) {
      throw error;
    }
  },

  // Obtener un movimiento por ID
  getMovimiento: async (id) => {
    try {
      const data = await api.get(`/api/movimientos-inventario/${id}/`);
      return data;
    } catch (error) {
      throw error;
    }
  },

  // Registrar entrada de inventario
  registrarEntrada: async (entradaData) => {
    try {
      const data = await api.post('/api/movimientos-inventario/entrada/', entradaData);
      return data;
    } catch (error) {
      throw error;
    }
  },

  // Registrar salida de inventario
  registrarSalida: async (salidaData) => {
    try {
      const data = await api.post('/api/movimientos-inventario/salida/', salidaData);
      return data;
    } catch (error) {
      throw error;
    }
  },

  // Ajustar inventario
  ajustarInventario: async (ajusteData) => {
    try {
      const data = await api.post('/api/movimientos-inventario/ajuste/', ajusteData);
      return data;
    } catch (error) {
      throw error;
    }
  },

  // Obtener stock actual por producto
  getStockProducto: async (productoId) => {
    try {
      const data = await api.get(`/api/inventario/stock/${productoId}/`);
      return data;
    } catch (error) {
      throw error;
    }
  },

  // Obtener historial de movimientos por producto
  getHistorialProducto: async (productoId, params = {}) => {
    try {
      const data = await api.get(`/api/inventario/historial/${productoId}/`, params);
      return data;
    } catch (error) {
      throw error;
    }
  },

  // Obtener reporte de inventario
  getReporteInventario: async (params = {}) => {
    try {
      const data = await api.get('/api/inventario/reporte/', params);
      return data;
    } catch (error) {
      throw error;
    }
  },

  // Obtener productos próximos a vencer
  getProductosProximosVencer: async (dias = 30) => {
    try {
      const data = await api.get('/api/inventario/proximos-vencer/', { dias });
      return data;
    } catch (error) {
      throw error;
    }
  },

  // Obtener datos para el gráfico de movimientos
  getGraficoMovimientos: async () => {
    try {
      const data = await api.get('/api/movimientos-inventario/grafico_movimientos/');
      return data;
    } catch (error) {
      throw error;
    }
  },

  // Obtener datos para el gráfico por farmacia
  getGraficoPorFarmacia: async () => {
    try {
      const data = await api.get('/api/movimientos-inventario/grafico_por_farmacia/');
      return data;
    } catch (error) {
      throw error;
    }
  }
};

export default inventarioService;

// Made with Bob
